"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.terms = terms;
exports.searchHelp = searchHelp;
const norm = (s) => s.toLowerCase().replace(/[^\p{L}\p{N}\s-]/gu, ' ');
/** Words of 2+ letters; "rto" and "cod" count. */
function terms(query) {
    return [...new Set(norm(query).split(/\s+/).filter((w) => w.length >= 2))];
}
function snippet(text, words) {
    const lower = text.toLowerCase();
    const at = Math.min(...words.map((w) => lower.indexOf(w)).filter((i) => i >= 0), text.length);
    let start = Math.max(0, at - 60);
    // start on a whole word
    if (start > 0)
        start = text.indexOf(' ', start) + 1 || start;
    return (start > 0 ? '…' : '') + text.slice(start, start + 180).trim() + (start + 180 < text.length ? '…' : '');
}
/**
 * Ranks sections: every word must appear in the article (title, keywords, summary or text);
 * a section scores more when the words are in its own title or text.
 */
function searchHelp(articles, query, limit = 30) {
    const words = terms(query);
    if (!words.length)
        return [];
    const hits = [];
    for (const a of articles) {
        const head = norm(`${a.title} ${a.keywords} ${a.summary}`);
        const all = head + ' ' + norm(a.sections.map((s) => `${s.title} ${s.text}`).join(' '));
        if (!words.every((w) => all.includes(w)))
            continue;
        const base = words.reduce((n, w) => n + (norm(a.title).includes(w) ? 10 : 0) + (norm(a.keywords).includes(w) ? 6 : 0) + (norm(a.summary).includes(w) ? 3 : 0), 0);
        let best = null;
        for (const s of a.sections) {
            const t = norm(s.title);
            const x = norm(s.text);
            const score = base + words.reduce((n, w) => n + (t.includes(w) ? 8 : 0) + (x.includes(w) ? 2 + Math.min(x.split(w).length - 2, 3) : 0), 0);
            const hit = { slug: a.slug, title: a.title, area: a.area, sectionId: s.id, sectionTitle: s.title, snippet: snippet(s.text, words), score };
            if (words.some((w) => t.includes(w) || x.includes(w)))
                hits.push(hit);
            if (!best || score > best.score)
                best = hit;
        }
        if (best && !hits.some((h) => h.slug === a.slug))
            hits.push({ ...best, sectionId: '', sectionTitle: '', snippet: a.summary });
    }
    return hits.sort((a, b) => b.score - a.score).slice(0, limit);
}
//# sourceMappingURL=help.js.map